import invoiceSerialList from "dummydata/invoiceSerialList";
import { DELETE_INVOICESERIAL } from "redux/actionTypes/actionTypes";
import { ADD_INVOICESERIAL } from "redux/actionTypes/actionTypes";

const initialState = {
  invoiceSerialList: invoiceSerialList,
  invoiceSerialTotal: 0,
};

const invoiceSerialReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_INVOICESERIAL:
      return {
        ...state,
        invoiceSerialList: state.invoiceSerialList.concat(action.payload),
      };
      break;
    case DELETE_INVOICESERIAL:
      return {
        ...state,
        invoiceSerialList: state.invoiceSerialList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    default:
      break;
  }
  return state;
};
export default invoiceSerialReducer;
